import { createContext, Dispatch, ReactNode, SetStateAction } from 'react';

const defaultLayout: CustomLayoutContextType = {
  menuDisplay: true,
  headerDisplay: true,
  setLayout: () => null,
  setMatch: () => null,
  match: {},
};

export interface CustomLayoutType {
  menuDisplay: boolean;
  headerDisplay: boolean;
}

export interface CustomLayoutContextType extends CustomLayoutType {
  setLayout: Dispatch<SetStateAction<CustomLayoutType>>;
  match: any;
  setMatch: Dispatch<SetStateAction<any>>;
}

export const CustomLayoutContext = createContext<CustomLayoutContextType>(defaultLayout);

export interface CustomProviderProps {
  children: ReactNode;
}
